module.exports = __webpack_public_path__ + "static/media/quang_new.3e2b0390.jpg";